export default "__VITE_ASSET__C1pUM3MR__"